<app-header></app-header>
<div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div>Отзывы</div>
  </div>
  <div class="links-block mt-4">
    <h2 class="mt-0 darkgrey">Наши услуги</h2>
    <div class="flex-row" style="flex-direction: row!important;">
      <div>
        <a routerLink="/expertkltp/">Экспертиза промышленной безопасности</a></div>
      <div style="width: 350px;">
        <a routerLink="/proekt-likvidatsii-i-konservatsii-opo/">Консервация и ликвидация опасных производственных объектов</a></div>
      <div>
        <a routerLink="/tekhnicheskoe-diagnostirovanie/">Техническое диагностирование</a></div>
      <div>
        <a routerLink="/identifikaciya/">Аудит и идентификация&nbsp;ОПО</a></div>
      <div>
        <a routerLink="/pasport/">Паспорт технического устройства&nbsp;на&nbsp;ОПО</a></div>
    </div>
  </div>
  <div class="we-offer row mt-70">
    <h1 class="w-100">Отзывы
      <div class="filters-red display-mobile">
        <div class="sorting first" (click)="showAllOptions = !showAllOptions;">
          <svg style="width: 22px; height: 22px;" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="54" height="54" fill="#880000"/>
            <rect x="12" y="12" width="30" height="30" fill="white"/>
          </svg>
          {{getSelectedFilter().label}}
        </div>
        <div class="flex-column c-select" *ngIf="showAllOptions">
          <div class="sorting" *ngFor="let filter of getUnselectedFilters()" (click)="setSelected(filter.label); showAllOptions = false; refreshData()">
            <svg style="width: 22px; height: 22px;" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="54" height="54" fill="#880000"/>
              <rect x="12" y="12" width="30" height="30" fill="white"/>
            </svg>
            {{filter.label}}
          </div>

        </div>
      </div>
    </h1>
    <div class="filters mb-5">
      <div class="rubrikator" #rubricator>
        <div [ngClass]="{'active': el.active, 'display-none': el.label === ''}" *ngFor="let el of categories, let i =index" (click)="setActive(i)">{{el.label}}</div>
      </div>
      <div class="filters-red hide-mobile">
        <div class="sorting first" (click)="showAllOptions = !showAllOptions;">
          <svg style="width: 22px; height: 22px;" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="54" height="54" fill="#880000"/>
            <rect x="12" y="12" width="30" height="30" fill="white"/>
          </svg>
          {{getSelectedFilter().label}}
        </div>
        <div class="flex-column c-select" *ngIf="showAllOptions">
          <div class="sorting" *ngFor="let filter of getUnselectedFilters()" (click)="setSelected(filter.label); showAllOptions = false; refreshData()">
            <svg style="width: 22px; height: 22px;" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="54" height="54" fill="#880000"/>
              <rect x="12" y="12" width="30" height="30" fill="white"/>
            </svg>
            {{filter.label}}
          </div>

        </div>
      </div>
    </div>
    <div id="accordion" class="w-100">
      <div class="card hover-pointer" *ngFor="let review of reviews">
        <div class="card-header " id="headingOne" [routerLink]="'/otzyvy/'+ review.id">
          <img [src]="review.scan" alt="">
          <div class="w-100">
            <button  class="btn w-100 accordion-label" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              {{review.title}}
              <svg style="width: 40px;" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 23L21 18L15 13" stroke="#880000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="18" cy="18" r="17.25" stroke="#880000" stroke-width="1.5"/>
              </svg>
            </button>
            <div [innerHTML]="review.content_html"></div>
          </div>

        </div>
      </div>
    </div>
    <div class="pag-cont">
      <div class="paginators"><svg *ngIf="currPage>1" class="hover-pointer" (click)="currPage=currPage-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="#880000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
        <span *ngFor="let page of createRange(pagesCount); let currentElementIndex=index" class="hover-pointer" [ngClass]="{'bold darkred': currPage === currentElementIndex+1}">
          <span (click)="currPage = currentElementIndex+1; refreshData()">{{currentElementIndex+1}}</span>
        </span>
        <svg *ngIf="currPage<pagesCount" class="hover-pointer" (click)="currPage=currPage+1; refreshData();" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="#880000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

      </div>
    </div>
  </div>

</div>
<app-footer></app-footer>
